import { render, staticRenderFns } from "./PrevPageSVG.vue?vue&type=template&id=56d92a79&"
import script from "./PrevPageSVG.vue?vue&type=script&lang=js&"
export * from "./PrevPageSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports